export default __webpack_public_path__ + "static/media/(84).5d9e59ca.jpg";